enum PromotionType {
    ClaimSubmission = 'ClaimSubmission',
    Redemption = 'Redemption',
}

export default PromotionType;
